import { useAuth } from "@/state/auth";
import { useMemo } from "react";

export function usePermissions() {
  const profile = useAuth((state) => state.profile);

  const permissions = useMemo(() => {
    return new Set(profile?.permissions ?? []);
  }, [profile?.permissions]);

  const isSuperadmin = profile?.isSuperadmin ?? false;

  const can = (resource: string, action: string): boolean => {
    if (isSuperadmin) return true;
    return permissions.has(`${resource}:${action}`);
  };

  const canView = (resource: string): boolean => can(resource, "view");
  const canCreate = (resource: string): boolean => can(resource, "create");
  const canEdit = (resource: string): boolean => can(resource, "edit");
  const canDelete = (resource: string): boolean => can(resource, "delete");

  return {
    can,
    canView,
    canCreate,
    canEdit,
    canDelete,
    isSuperadmin,
    permissions,
  };
}
